<template>
  <div>
    <div>
      <label class="a-form-label" for="gatheringSelected">{{ $t('label-edit-business-gathering') }}*</label>
      <p>
        <v-select class="a-form-control" id="gatheringSelected" v-model="selectedGathering" :options="options" :selectable="selectable" :clearable="false" autocomplete />
        <slot></slot>
      </p>
      <p v-if="gatheringId !== -1">
        <a href="javascript:void();" @click="removeGathering" class="edit-business__remove-link"> <span class="edit-business__remove-icon"></span>{{ $t('quit-current-gathering-btn') }} </a>
      </p>
    </div>
  </div>
</template>

<script>
import GatheringService from '@/services/gathering'
import VSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  components: {
    VSelect
  },
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      gatherings: []
    }
  },
  methods: {
    selectable: function(option) {
      return !option.isDisabled
    },
    refreshGatheringList: async function() {
      this.gatherings = [{ value: -1, isDisabled: true, text: this.$t('business-gathering-choose') }]
      let gatherings = await GatheringService.getAllGathering()
      gatherings.forEach(gathering => {
        const isPrivate = !gathering.IsPublic
        const isFull = gathering.IsFull
        let name = isPrivate ? gathering.Name + ' ' + this.$t('gathering-list-private') : gathering.Name
        name += isFull ? ' ' + this.$t('gathering-list-full') : ''
        this.gatherings.push({ value: gathering.Id, text: name, isDisabled: gathering.RegistrationClosed })
      })
    },
    removeGathering: function() {
      this.$emit('quitGathering')
    }
  },
  computed: {
    gatheringId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    selectedGathering: {
      get() {
        return this.options.find(x => x.value === this.gatheringId)
      },
      set(val) {
        this.gatheringId = val ? val.value : ''
      }
    },
    options: function() {
      return this.gatherings.map(x => ({ value: x.value, label: x.text, isDisabled: x.isDisabled }))
    }
  },
  async mounted() {
    await this.refreshGatheringList()
  }
}
</script>
